import { Stack, TextField} from "@mui/material"

export const Filter = ({ setFilterArray, copyArray }) => {

    const handleSubmit = (e) => {
        e.preventDefault();
        const filter = e.target.value.toUpperCase();

        const newFilterArray = copyArray?.filter((row) => row.name?.toUpperCase().includes(filter) || row.tel?.toString().includes(filter) || row.cif?.toString().includes(filter) || row.email?.toUpperCase().includes(filter));

        setFilterArray(newFilterArray)
    }

    return (
        <Stack component='form' flexDirection='row' justifyContent='space-between' width='100%' mb='1rem' >
            <TextField
                label="Filtrar por empresa, teléfono o email"
                defaultValue=""
                size="small"
                name="filter"
                sx={{width:'100%'}}
                onChange={handleSubmit}
            />

        </Stack>
    )
}
